import {
  createSystem,
  defaultConfig,
  defineConfig,
  defineTextStyles,
} from "@chakra-ui/react";
import "@fontsource-variable/montserrat/index.css";

const textStyles = defineTextStyles({
  h1: {
    description: "H1 text style, use only for large breakpoints",
    value: {
      fontFamily: "sansSerif",
      fontWeight: "medium",
      fontSize: "48px",
      lineHeight: "1.2",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "None",
    },
  },
  h1Bold: {
    description: "H1 bold text style, use only for large breakpoints",
    value: {
      fontFamily: "sansSerif",
      fontWeight: "bold",
      fontSize: "48px",
      lineHeight: "1.2",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "None",
    },
  },
  h2: {
    description: "H2 text style",
    value: {
      fontFamily: "sansSerif",
      fontWeight: "medium",
      fontSize: "40px",
      lineHeight: "1.2",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "None",
    },
  },
  h2Bold: {
    description: "H2 text style",
    value: {
      fontFamily: "sansSerif",
      fontWeight: "bold",
      fontSize: "40px",
      lineHeight: "1.2",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "None",
    },
  },
  h3: {
    description: "H3 text style",
    value: {
      fontFamily: "sansSerif",
      fontWeight: "medium",
      fontSize: "28px",
      lineHeight: "1.2",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "None",
    },
  },
  h3Bold: {
    description: "H3 bold text style",
    value: {
      fontFamily: "sansSerif",
      fontWeight: "bold",
      fontSize: "28px",
      lineHeight: "1.2",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "None",
    },
  },
  h4: {
    description: "H4 text style",
    value: {
      fontFamily: "sansSerif",
      fontWeight: "medium",
      fontSize: "24px",
      lineHeight: "1.2",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "None",
    },
  },
  h4Bold: {
    description: "H4 bold text style",
    value: {
      fontFamily: "sansSerif",
      fontWeight: "semibold",
      fontSize: "24px",
      lineHeight: "1.2",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "None",
    },
  },
  h5: {
    description: "H5 text style",
    value: {
      fontFamily: "sansSerif",
      fontWeight: "medium",
      fontSize: "20px",
      lineHeight: "1.2",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "None",
    },
  },
  h5Bold: {
    description: "H5 bold text style",
    value: {
      fontFamily: "sansSerif",
      fontWeight: "semibold",
      fontSize: "20px",
      lineHeight: "1.2",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "None",
    },
  },
  bodyLarge: {
    base: {
      description: "Body large base text style",
      value: {
        fontFamily: "sansSerif",
        fontWeight: "normal",
        fontSize: "18px",
        lineHeight: "1.6",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
    strong: {
      description: "Body large strong text style",
      value: {
        fontFamily: "sansSerif",
        fontWeight: "semibold",
        fontSize: "18px",
        lineHeight: "1.6",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
    slant: {
      description: "Body large slant text style",
      value: {
        fontFamily: "sansSerif",
        fontStyle: "italic",
        fontSize: "18px",
        lineHeight: "1.6",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
  },
  bodyRegular: {
    base: {
      description: "Body regular base text style",
      value: {
        fontFamily: "sansSerif",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "1.4",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
    strong: {
      description: "Body regular strong text style",
      value: {
        fontFamily: "sansSerif",
        fontWeight: "semibold",
        fontSize: "16px",
        lineHeight: "1.4",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
    slant: {
      description: "Body regular slant text style",
      value: {
        fontFamily: "sansSerif",
        fontStyle: "italic",
        fontSize: "16px",
        lineHeight: "1.4",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
  },
  bodySmall: {
    base: {
      description: "Body small base text style",
      value: {
        fontFamily: "sansSerif",
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "1.4",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
    strong: {
      description: "Body small strong text style",
      value: {
        fontFamily: "sansSerif",
        fontWeight: "semibold",
        fontSize: "14px",
        lineHeight: "1.4",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
    slant: {
      description: "Body small slant text style",
      value: {
        fontFamily: "sansSerif",
        fontStyle: "italic",
        fontSize: "14px",
        lineHeight: "1.4",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
  },
  bodyXSmall: {
    base: {
      description: "Body xsmall base text style",
      value: {
        fontFamily: "sansSerif",
        fontWeight: "normal",
        fontSize: "12px",
        lineHeight: "1.4",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
    strong: {
      description: "Body xsmall strong text style",
      value: {
        fontFamily: "sansSerif",
        fontWeight: "semibold",
        fontSize: "12px",
        lineHeight: "1.4",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
    slant: {
      description: "Body xsmall slant text style",
      value: {
        fontFamily: "sansSerif",
        fontStyle: "italic",
        fontSize: "12px",
        lineHeight: "1.4",
        letterSpacing: "0",
        textDecoration: "None",
        textTransform: "None",
      },
    },
  },
  caption: {
    description: "Caption text style",
    value: {
      fontFamily: "sansSerif",
      fontStyle: "semibold",
      fontSize: "12px",
      lineHeight: "1.4",
      letterSpacing: "0",
      textDecoration: "None",
      textTransform: "uppercase",
    },
  },
});

const config = defineConfig({
  globalCss: {
    // Safety net for the full-bleed section pattern used across the home page
    // (HeroCarousel, ServiceHighlights, HowItWorks, WhyChooseUs, BrandCarousel,
    // CTASection, HomeReferralRibbon): `w="100vw"` with `left: 50%; ml: -50vw`.
    //
    // 100vw includes the vertical scrollbar gutter, so on any page tall enough to
    // scroll those sections end up ~15px wider than the content box and the document
    // gains a horizontal scrollbar.
    //
    // `clip`, deliberately not `hidden`: `overflow-x: hidden` on html/body silently
    // turns it into a scroll container, which breaks `position: sticky` descendants —
    // and the navbar is sticky on every page that uses PublicPageLayout.
    body: {
      overflowX: "clip",
    },
  },
  theme: {
    textStyles,
    breakpoints: {
      base: "0px",
      tablet: "768px",
      laptop: "960px",
      desktop: "1380px",
    },
    keyframes: {
      carouselspin: {
        from: { transform: "translateX(0%)" },
        to: { transform: "translateX(-100%)" },
      },
    },
    tokens: {
      animations: {
        carousel: { value: "carouselspin 20s linear infinite" },
      },
      fonts: {
        sansSerif: { value: "montserrat variable" },
      },
      fontWeights: {
        b: { value: 700 },
        regular: { value: 400 },
        smb: { value: 600 },
        md: { value: 500 },
      },
      colors: {
        /* Primitives */
        greyscale: {
          50: { value: "#FBFCFC" },
          100: { value: "#F8FAFA" },
          200: { value: "#F3F7F7" },
          300: { value: "#E9F2F2" },
          400: { value: "#E3ECEC" },
          500: { value: "#B9C2C2" },
          600: { value: "#909797" },
          700: { value: "#6B7070" },
          800: { value: "#464A4A" },
          900: { value: "#262828" },
          950: { value: "#161818" },
        },
        green: {
          50: { value: "#C8FFCA" },
          100: { value: "#8CFF94" },
          200: { value: "#31EA47" },
          300: { value: "#28CA3C" },
          400: { value: "#20B034" },
          500: { value: "#1A922A" },
          600: { value: "#13731F" },
          700: { value: "#0D5715" },
          800: { value: "#043C0C" },
          900: { value: "#022505" },
          950: { value: "#011402" },
        },
        blue: {
          50: { value: "#EBF2FB" },
          100: { value: "#D8E7F8" },
          200: { value: "#B0D0F0" },
          300: { value: "#81BAE9" },
          400: { value: "#5FA2D3" },
          500: { value: "#4D84AD" },
          600: { value: "#3E6A8C" },
          700: { value: "#2C4F69" },
          800: { value: "#1C3648" },
          900: { value: "#0E1F2C" },
          950: { value: "#05121B" },
        },
        red: {
          50: { value: "#FDEDED" },
          100: { value: "#FBDBDB" },
          200: { value: "#F7B6B7" },
          300: { value: "#F48A8C" },
          400: { value: "#F25A5D" },
          500: { value: "#DE2D33" },
          600: { value: "#B12227" },
          700: { value: "#87171B" },
          800: { value: "#630E11" },
          900: { value: "#3D0607" },
          950: { value: "#2A0303" },
        },
      },
    },
    semanticTokens: {
      colors: {
        greyscale: {
          surface: {
            subtle: { value: "#FFFFFF" },
            default: { value: "{colors.greyscale.100}" },
            disabled: { value: "{colors.greyscale.200}" },
            darker: { value: "{colors.greyscale.400}" },
          },
          border: {
            disabled: { value: "{colors.greyscale.300}" },
            default: { value: "{colors.greyscale.500}" },
            darker: { value: "{colors.greyscale.700}" },
          },
          text: {
            negative: { value: "{colors.greyscale.50}" },
            disabled: { value: "{colors.greyscale.400}" },
            caption: { value: "{colors.greyscale.500}" },
            body: { value: "{colors.greyscale.800}" },
            subtitle: { value: "{colors.greyscale.900}" },
            title: { value: "{colors.greyscale.950}" },
          },
        },

        primary: {
          surface: {
            subtle: { value: "{colors.green.50}" },
            lighter: { value: "{colors.green.200}" },
            default: { value: "{colors.green.400}" },
            darker: { value: "{colors.green.700}" },
          },
          border: {
            subtle: { value: "{colors.green.100}" },
            lighter: { value: "{colors.green.300}" },
            default: { value: "{colors.green.500}" },
            darker: { value: "{colors.green.800}" },
          },
          text: {
            label: { value: "{colors.green.600}" },
          },
        },

        secondary: {
          surface: {
            subtle: { value: "{colors.blue.50}" },
            lighter: { value: "{colors.blue.200}" },
            default: { value: "{colors.blue.400}" },
            darker: { value: "{colors.blue.700}" },
          },
          border: {
            subtle: { value: "{colors.blue.100}" },
            lighter: { value: "{colors.blue.400}" },
            default: { value: "{colors.blue.600}" },
            darker: { value: "{colors.blue.900}" },
          },
          text: {
            label: { value: "{colors.blue.600}" },
            label2: { value: "{colors.blue.700}" },
          },
        },

        danger: {
          surface: {
            subtle: { value: "{colors.red.50}" },
            lighter: { value: "{colors.red.200}" },
            default: { value: "{colors.red.400}" },
            darker: { value: "{colors.red.700}" },
          },
          border: {
            subtle: { value: "{colors.red.100}" },
            lighter: { value: "{colors.red.300}" },
            default: { value: "{colors.red.500}" },
            darker: { value: "{colors.red.800}" },
          },
          text: {
            label: { value: "{colors.red.600}" },
          },
        },
      },
    },
  },
});

const system = createSystem(defaultConfig, config);

export default system;
